import { createFileRoute, Navigate } from '@tanstack/react-router';

const AuthIndexPage = () => <Navigate to='/auth/sign-in' replace />;

export const Route = createFileRoute('/auth/')({
  component: AuthIndexPage,
});
